// extracted by mini-css-extract-plugin
export default {"isActive":"styles_isActive__+AdoO","isInactive":"styles_isInactive__01WMd","subtitleSection":"styles_subtitleSection__m9hyE"};